export const primaryNavigation = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'About', path: '/about' },
  { label: 'Industries', path: '/industries' },
  { label: 'Equipment', path: '/equipment' },
  { label: 'Contact', path: '/contact' },
];

export const serviceNavigation = [
  { label: 'Hydraulic Cylinder Repair', path: '/services/hydraulics' },
  { label: 'Gearbox Repair', path: '/services/gearboxes' },
  { label: 'Industrial Repair', path: '/services/industrial-repair' },
];
